import { useTheme } from 'styled-components';

type PropsType = {
  overrideStyle?: Record<any, any>;
};

const FacebookIcon = ({ overrideStyle = {} }: PropsType) => {
  const theme = useTheme();
  return (
    <svg
      viewBox="0 0 768 764"
      style={{ width: '30px', height: '30px', ...overrideStyle }}
    >
      <path
        d="M384 0a384 384 0 00-60 763.3V495h-97.5V384H324v-84.6c0-96.2 57.3-149.4 145-149.4 42 0 86 7.5 86 7.5V252h-48.4c-47.7 0-62.6 29.6-62.6 60v72h106.5l-17 111H444v268.3A384 384 0 00384 0z"
        fill={overrideStyle.color || theme.white}
        fillRule="evenodd"
      />
    </svg>
  );
};

export default FacebookIcon;
